<template>
  <div
    class="inline-flex items-center rounded-xl border border-solid border-red-200 bg-red-100 px-2 py-0.5 text-red-400"
  >
    <span class="text-xs font-bold leading-4">★ {{ t('title') }} ★</span>
  </div>
</template>

<script setup lang="ts">
  const { t } = useI18n({ useScope: 'local' });
</script>

<i18n lang="json">
{
  "en-int": {
    "title": "Most Popular"
  },
  "en-jp": {
    "title": "Most Popular"
  },
  "en-tw": {
    "title": "Most Popular"
  },
  "en-kr": {
    "title": "Most Popular"
  },
  "en-americas": {
    "title": "Most Popular"
  },
  "en-asia-pacific": {
    "title": "Most Popular"
  },
  "en-emea": {
    "title": "Most Popular"
  },
  "ja-jp": {
    "title": "最も人気"
  },
  "zh-cn": {
    "title": "最受欢迎"
  },
  "zh-tw": {
    "title": "最受歡迎"
  }
}
</i18n>
